﻿window.integralsedit = function (moment) {

    var instance = {
        processedit: function (args) {
            var changed = false;

            for (let i = 0; i < args.data.length; i++) {
                const data = args.data[i];

                const sel = `tr[data-ti-id="${data.ti_id}"][data-channeltype="${data.channelType}"][data-titype="${data.tiType}"] > td[data-ivdate="${data.date}"]`;
                const el = document.querySelector(sel);
                if (!el)
                    continue;
                const row = el.parentElement;

                const integralsparmel = row.querySelector('.integralsparm');
                if (!integralsparmel)
                    continue;
                const integralsparm = JSON.parse(integralsparmel.value);

                for (let j = 0; j < integralsparm.length; j++) {
                    const parm = integralsparm[j];
                    const dataItem = args.data.find(r => r.channelType == parm.ChannelType && new Date(r.date).getTime() == new Date(parm.EventDateTime).getTime());
                    if (dataItem) {
                        parm.Data = dataItem.newValue;
                    }
                }

                integralsparmel.value = JSON.stringify(integralsparm);

                if (data.oldValue == data.newValue)
                    continue;

                const coef = row.querySelector('.coef');
                const coefVal = parseInt(coef.getAttribute('data-val'));
                const ivsd = row.querySelector('.ivsd');
                const ivsd_date = ivsd.getAttribute('data-ivdate');
                const ivfd = row.querySelector('.ivfd');
                const ivfd_date = ivfd.getAttribute('data-ivdate');
                const ivdiff = row.querySelector('.ivdiff');
                const valForDrums = row.querySelector('.valForDrums');

                const data_sd = args.data.find(r => r.channelType == data.channelType && new Date(r.date).getTime() == new Date(ivsd_date).getTime());
                const data_fd = args.data.find(r => r.channelType == data.channelType && new Date(r.date).getTime() == new Date(ivfd_date).getTime());

                if (ivsd && data_sd) {
                    ivsd.innerHTML = data_sd.newValue != null ?
                        data_sd.newValue.toLocaleString('ru-RU', { minimumFractionDigits: 7, maximumFractionDigits: 7 }) :
                        '-';
                }
                if (ivfd && data_fd) {
                    ivfd.innerHTML = data_fd.newValue != null ?
                        data_fd.newValue.toLocaleString('ru-RU', { minimumFractionDigits: 7, maximumFractionDigits: 7 }) :
                        '-';
                }
                if (ivdiff && data_sd && data_fd) {
                    ivdiff.innerHTML = data_sd.newValue != null && data_fd.newValue != null ?
                        (data_fd.newValue - data_sd.newValue).toLocaleString('ru-RU', { minimumFractionDigits: 7, maximumFractionDigits: 7 }) :
                        '-';
                }
                if (valForDrums && data_sd && data_fd && !isNaN(coefVal)) {
                    valForDrums.innerHTML = data_sd.newValue != null && data_fd.newValue != null ?
                        (coefVal * (data_fd.newValue - data_sd.newValue)).toLocaleString('ru-RU', { minimumFractionDigits: 0, maximumFractionDigits: 7 }) :
                        '-';
                }

                row.classList.add('integralsedit-changed-row');

                changed = true;
            }



            //const row = document.getElementById(args.rowid);

            //const channelType = parseInt(row.getAttribute('data-channeltype'));
            //const sd = moment(row.getAttribute('data-tiversd'), 'YYYYMMDDHHmmss').toDate();
            //const fd = moment(row.getAttribute('data-tiverfd'), 'YYYYMMDDHHmmss').toDate();
            //fd.setMinutes(fd.getMinutes() + 1);


            //const integralsparmel = document.getElementsByName(args.integralsparmid)[0];
            //const integralsparm = JSON.parse(integralsparmel.value);
            //for (let i = 0; i < integralsparm.length; i++) {
            //    const parm = integralsparm[i];
            //    const data = args.data.find(r => r.channelType == parm.ChannelType && new Date(r.date).getTime() == new Date(parm.EventDateTime).getTime());
            //    if (data) {
            //        if ((parm.Data | 0) != data.newValue)
            //            changed = true;
            //        parm.Data = data.newValue;
            //    }
            //}
            //integralsparmel.value = JSON.stringify(integralsparm);

            if (changed) {
                document.body.classList.add('integralsedit-changed');
                document.querySelectorAll('.excelexport').forEach((el) => {
                    el.disabled = true;
                });
                document.querySelectorAll('.reservationbtn').forEach((el) => {
                    el.disabled = true;
                });
                document.querySelectorAll('.sumForDrums').forEach((el) => {
                    el.innerHTML = '';
                });
            }

            
        },
        clear: function () {
            document.body.classList.remove('integralsedit-changed');
            document.querySelectorAll('.excelexport').forEach((el) => {
                el.disabled = false;
            });
        }
    }
    return instance;
}(moment);